import { gray0 } from 'emerald-ui/dist/globals/colors';
import { ProgressSteps_Root } from 'emerald-ui/dist/ProgressSteps';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const ProgressBar_Root = styled.div`
    box-sizing: border-box;
    flex-grow: 1;
    background: ${gray0};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 6rem;
    font-size: 1.25rem; /* 20px */

    ${ProgressSteps_Root} {
        z-index: 0;
        width: 100%;
        max-width: 40em;
        font-size: inherit;
    }

    ${theme.breakpoints.down('sm')} {
        padding: 2em;
    }

    ${theme.breakpoints.only('xs')} {
        font-size: 1rem; /* 16px */
        span {
            font-size: .75rem;
        }
    }
`;
